import styled from 'styled-components';

const MyDiv = styled.div`

.page_heading {
  margin-bottom: 24px;
}

.flex_header {
  align-items: center;
  justify-content: space-between;
}
.content{
 filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
}
.btn {
  background-color: #006838;
  color: white;
  border-radius: 6px;
  padding: 8px 8px;
  &:hover {
    background-color: #006838;
    color: white;
  }
}

.card_box {
  background: white;
  padding: 15px 10px;
  border-radius: 16px;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}


.card_label {
  color: #23272E;
}

.card_value {
font-size: 36px;
  color: #23272E;
}
`;

export default MyDiv;
